import { render } from "./HorseWeights.vue?vue&type=template&id=a5a85372"
import script from "./HorseWeights.vue?vue&type=script&lang=js"
export * from "./HorseWeights.vue?vue&type=script&lang=js"

import exportComponent from "/Users/iomac/Progetti/equiup/equiupmaneggi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__